import { render } from "./CIS-Resource-Advisory-RelatedBenchmark.vue?vue&type=template&id=ee198cc6"
import script from "./CIS-Resource-Advisory-RelatedBenchmark.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-Advisory-RelatedBenchmark.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__